// extracted by mini-css-extract-plugin
export default {"overlay":"ModalWindow_overlay__eLj0p","content":"ModalWindow_content__fS1Pu"};